import Gumshoe from 'gumshoejs'

import {q} from '../helper/q'

export const productMenuInit = () => {
  const productMenuSlider = q('.productMenuSlider a')
  if (!productMenuSlider) return null
  let spy = new Gumshoe('.productMenuSlider a', {
    nested: true,
    nestedClass: 'active',
    reflow: true,
    offset: 70
  })
}
